import React, { useState, useRef, useEffect } from 'react';
import { useCookies } from 'react-cookie'
import { connect } from 'react-redux';
import { clearNotify, updateNotify, getNotify } from '../reducers/formActions'

import { api } from '../utils/endpoint.js'

import ThaivivatLogo from '../components/ThaivivatLogo.js'
import ProgressWaiting from '../components/progress-wating.js'
import { validateNotify } from '../utils/validate.js'

import iconWarningAlert from '../images/alert/ic_warning.svg'
import iconCloseAlert from '../images/alert/ic_close.svg'


function InformNotifyNoComponent(props) {
  let onSuccess = props.onSuccess
  let onUploadDocAction = props.onUploadDocAction

  const [ notifyNo, setNotifyNo ] = useState("")
  const [ isShowAlert, setIsShowAlert ] = useState(false)
  const [ alertText, setAlertText ] = useState('')
  const [ isError, setIsError ] = useState(false)
  const [ isShowLoading, setIsShowLoading ] = useState(false)
  
  

  function onChangeNotify( event ){
    if ( validateNotify( event )) {
      return (event.target.value).substring(0, (event.target.value).length-1).replace(/\D+/g, '')
    }
    else if( event.nativeEvent.data === undefined){
      return ""
    }
    else{
      return event.target.value.replace(/\D+/g, '')
    }
  }

  function callApiGetCarLicense() {
  

    fetch(api.newcc.getCarLicenses(`notify_number=${notifyNo}`))
    .then( async (response) => {
      if(response.ok){
        return response.json();         
      }
      throw ({status:response.status, body:  await response.json()});
    })
    .then(data => onSuccessCallApiGetCarLicense(data), (error) => {
      if (error) { 
        // props.updateNotify(notifyNo)
        // const response = [
        //   {
        //       "car_license_alp": "5กด",
        //       "car_license_no": "7124",
        //       "car_license_province": "กท",
        //       "register_plate": "N",
        //       "driver_name": null,
        //       "sufferer_type": 0
        //   },
        //   {
        //       "car_license_alp": "กตล",
        //       "car_license_no": "525",
        //       "car_license_province": "นภ",
        //       "register_plate": "N",
        //       "driver_name": "ไม่ทราบชื่อ",
        //       "sufferer_type": 1
        //   }
        // ]
        // onSuccess(response)
        onFailCallApiGetCarLicense( error )
      }
    }).catch((error) => {
      onFailCallApiGetCarLicense( error )
      // onErrorCallApiConfirmContactInfo({title:'เกิดข้อผิดพลาด กรุณาติดต่อฝ่ายลูกค้าสัมพันธ์ โทร. 1231 กด 4',message:''})
      // setIsShowLoading(false)
    })
  }

  function onSuccessCallApiGetCarLicense( response  ){
    setIsShowLoading(false)
    if(response !== null && response !== undefined){

      if(response.length > 0){
        props.updateNotify(notifyNo)
        let result = []
        for (let i = 0; i < response.length; i++) {
          const res = response[i]
          if (
            (res.car_license_alp && res.car_license_alp != 'null') ||
            (res.car_license_no && res.car_license_no != 'null') ||
            (res.car_license_province && res.car_license_province != 'null')
          ) {
            result.push({
              car_license_alp: res.car_license_alp,
              car_license_no:  res.car_license_no && res.car_license_no != 'null' ? res.car_license_no : '',
              car_license_province: res.car_license_province && res.car_license_province != 'null' ? res.car_license_province : '',
              driver_name: res.driver_name,
              register_plate: res.register_plate,
              sufferer_type: res.sufferer_type,
            })
          }
        }
        onSuccess(result)
      }
      else{
        onFailCallApiGetCarLicense( { ErrorDesc : "ไม่พบรายการ" } )
      }
    }
    else{
      // props.updateNotify(notifyNo)
      // response = [
      //   {
      //       "car_license_alp": "5กด",
      //       "car_license_no": "7124",
      //       "car_license_province": "กท",
      //       "register_plate": "N",
      //       "driver_name": null,
      //       "sufferer_type": 0
      //   },
      //   {
      //       "car_license_alp": "กตล",
      //       "car_license_no": "525",
      //       "car_license_province": "นภ",
      //       "register_plate": "N",
      //       "driver_name": "ไม่ทราบชื่อ",
      //       "sufferer_type": 1
      //   }
      // ]
      // onSuccess(response)
      onFailCallApiGetCarLicense( response )
    }
    
  }

  function onFailCallApiGetCarLicense( data ){
    if (data && data?.status >= 400) {
      const statusCode = data.status.toString()
      if(statusCode[0] == '4'){
        switch (data.status) {
          case 400:
            setAlertText(data.body.message)
            setIsShowAlert(true)
            break;
          case 404:
            setAlertText(data.body.message)
            setIsShowAlert(true)
            break;
          default:
            setAlertText('เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง')
            setIsShowAlert(true)
        }
      } else if(statusCode[0] == '5'){
        setAlertText(data.body.message)
        setIsShowAlert(true)
      }
    }else{
      setAlertText("เกิดข้อผิดพลาด กรุณาติดต่อฝ่ายลูกค้าสัมพันธ์ โทร. 1231 กด 4")
      setIsShowAlert(true)
    }

    setIsShowLoading(false)
    showAlert()
  }

  function submit(  ){

    if ( notifyNo === "" ) {
      setIsError(true)
    } else {
      if(isShowLoading == false) {
        setIsShowLoading(true)
        setIsError(false)
        callApiGetCarLicense();
      }
    }
  }


  const timer = useRef(null);
  const [ counter, setCounter ] = useState(1);
  function showAlert(){
    clearIntervalAlert()
    setIsShowAlert(true)
    setCounter(1)
    setAlertTimer()
  }
  function closeAlert(){
    clearIntervalAlert()
 
  }
  function setAlertTimer(){
    timer.current = setInterval(() => {
      setCounter((v) => v + 1)
    }, 1000);
    return () => clearTimeout(timer.current);
  }
  useEffect(() => {
    if (counter >= 5){
      clearIntervalAlert()
    }
  }, [counter]);

  function clearIntervalAlert(){
    clearInterval(timer.current);
    setIsShowAlert(false);
    setCounter(1)
  }
  
  return (
    <div className=' flex-wrap w-full '>

      <div data-testid='toast-message-text' className={((isShowAlert)? ' fixed ' : ' hidden ' )+ 'bg-[#252525]  text-white  top-[5%]  flex inset-x-0 mx-auto shadow-alert  w-fit h-[40px] py-[10px] px-[12px] mb-[40px] rounded-lg '}>

        <img src={iconWarningAlert} alt="icon-warning-alert" className='w-[16px] h-[16px] mr-[8px] my-auto' />

        <span data-testid='toast-description-text' className='text-sm not-italic font-normal  my-auto' >{alertText}</span>

        <button onClick={(e) => { closeAlert() }}><img src={iconCloseAlert} alt="icon-close-alert " className='w-[16px] h-[16px] ml-[8px] my-auto' /></button>
      </div>

    <div className="flex-none md:hidden w-full bg-green-500 py-[11px] pl-4">
      <div className=''>
        <ThaivivatLogo></ThaivivatLogo>
      </div>
    </div>
    
    <div className='flex flex-wrap w-full justify-center '>
      <div className='flex-wrap w-full md:w-[428px] pt-10 px-4 md:px-11'>

        <div className='flex-wrap w-full'>
          <span className='flex w-full text-2xl not-italic md:text-[32px] font-medium leading-[44px]'>กรุณาระบุเลขรับแจ้ง</span>
          <span className='flex w-full mt-4 text-base not-italic font-normal leading-5 text-grey-600'>ที่พนักงานไทยวิวัฒน์ได้ออกให้กับคุณเพื่อทำรายการ เรียกร้องสินไหมออนไลน์</span>
        </div>

        <div className='flex-wrap w-full mt-6 md:mt-10'>

          <div className='flex flex-wrap w-full '>
            <span className='w-full font-medium not-italic text-black text-sm'>เลขรับแจ้ง</span>
            <div className=' flex-wrap w-full mt-1'>
              <input  
              data-testid='notifyNo-input'
              value={ notifyNo } onChange={ (e)=> { setNotifyNo(onChangeNotify(e)); } } type={'search'} className={'w-full md:max-w-[360px] h-[48px] font-prompt text-md border py-2 px-4 rounded-lg focus:outline-none focus:border-green-500 focus:border-1 focus:box-border focus:shadow-normal focus:shadow-green-400   ' + ( (false)? ' border-red-500 ' : ' border-grey-300 ' )} placeholder='ระบุ' />
            </div>  

          </div>
        

        </div>
        

        <div className='w-full mt-1'>
          {
            ( isError )?
              <span data-testid='error-message-text' className='flex w-full text-xs text-red-500'>กรุณาระบุเลขรับแจ้ง</span>
            :
              null
          }
        </div>

        


        <div className='w-full mt-6'>
          <button 
              data-testid='next-button'
              onClick={(e)=>{submit() }}
              className={'w-full lg:px-4 text-base leading-6 h-[48px]  md:h-12 font-medium rounded-lg border-radius-other  '+ ( (false)? ' bg-grey-600 text-white ' : ' bg-green-500 text-white ')}>
                ต่อไป
          </button>
        </div>




        <div className='w-full mt-6 md:mt-10'>
          <span className=' w-full text-base not-italic leading-5'>หากคุณไม่มีสามารถขอเลขรับแจ้งได้กับพนักงาน กรุณาติดต่อที่หมายเลข <span className='text-green-500'>1231 กด 4</span></span>
        </div>

        {/* <div className='w-full mt-6 md:mt-10'>
          <span onClick={ onUploadDocAction }  className='cursor-pointer not-italic font-normal  w-full text-base leading-5 text-green-500'>อัพโหลดเอกสารเพิ่มเติม</span>
        </div> */}

      </div>
    </div>

      {
        isShowLoading ?
          <ProgressWaiting />
        :
        null
      }

    </div>
  )
}


const mapStateToProps = state => {
  return state
}
const mapDispatchToProps = dispatch => {
  return {
    clearNotify : () =>  dispatch(clearNotify()),
    updateNotify : (notify) =>  dispatch(updateNotify( notify )),
    getNotify : () =>  dispatch(getNotify())
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(InformNotifyNoComponent);